import { GridCellProps } from '@progress/kendo-react-grid';
import { monthDateYearFormat } from 'utils/common';

type Props = {
  className?: string;
  e: GridCellProps;
};

const ShowDateCell = ({ className, e }: Props) => {
  const data = e?.dataItem;
  return (
    <td className={className ?? ''}>
      <div>{monthDateYearFormat(data.showStartDate)}</div>
    </td>
  );
};

export default ShowDateCell;
